import { useState, useEffect, type ReactNode } from 'react';
import type { IUser } from 'configcat-react';
import { ConfigCatUserContext } from '@contexts';
import { useSessionContext } from '@contexts';

const DEFAULT_USER = {
    identifier: `anonymous`,
    custom: {
        // Suppress ConfigCat warnings regarding specifying these values:
        account: `0`,
        community: `0`
    }
};

const ConfigCatUserProvider = ({ children }: { children: ReactNode }) => {
    const { session } = useSessionContext();
    const [user, setUser] = useState<IUser>(DEFAULT_USER);

    useEffect(() => {
        if (session) {
            setUser({
                identifier: String(session.idPayor),
                email: session.email ?? undefined,
                custom: {
                    account: String(session.idAccount),
                    community: String(session.idCommunity)
                }
            });
        } else {
            setUser(DEFAULT_USER);
        }
    }, [session]);

    return (
        <ConfigCatUserContext.Provider value={user}>
            {children}
        </ConfigCatUserContext.Provider>
    );
};

export default ConfigCatUserProvider;
